const {
    $, _, WebSocket, JSON, alert, setTimeout, console, document, window,
} = Function('return this')();
const { stringify, parse } = JSON;

const form = $('form');
const input = $('textarea', form).eq(0);
const output = $('textarea', form).eq(1);

const noop = () => {};

const functions = {
    beautify (msg) {
        const { data, callid } = msg;
        if (callid >= next_callid) {
            output.val(data);
        }
    },
};

input.on('change blur keyup cut paste', _.debounce(ev => {
    form.trigger('submit');
}, 500));

let next_callid = 0;
const ws = new WebSocket(form.data('url'));

const send = function (msg) {
    const { readyState } = ws;
    if (readyState === 0) {
        setTimeout(send, 16, msg);
    } else if (readyState === 1) {
        console.log('>', msg);
        ws.send(stringify(msg));
    } else {
        console.log('Dropped message', msg);
    }
};

$(ws).on({
    message (ev) {
        ev.preventDefault();
        const msg = parse(ev.originalEvent.data);
        console.log('<', msg);
        const { type } = msg;
        (functions[type] || noop)(msg);
    },
    error (ev) {
        ev.preventDefault();
        alert('Error.');
    },
    open (ev) {
        ev.preventDefault();
        form.trigger('submit');
    },
});

form.on({
    submit (ev) {
        ev.preventDefault();
        send({
            type: 'beautify',
            data: input.val(),
            opts: {},
            callid: ++next_callid,
        });
    },
});
